document.querySelectorAll('.wpforms-field').forEach(el => {
  let input = el.querySelector('textarea, input')
  if (!input) return

  let toggle = () => {
    el.classList.toggle('wpforms-field-filled', input.value.length > 0)
  }

  toggle()
  input.addEventListener('blur', toggle)
})
